// src/pages/AboutPage/AboutPage.jsx
import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col lg={8}>
          <Card className="shadow-lg border-0">
            <Card.Body className="p-4 p-md-5">
              <h2 className="mb-3 text-center" style={{ fontWeight: 700 }}>
                Little Paws Place™
              </h2>
              <p className="text-center text-muted mb-4">
                Smart identity & AI support for the pets you love.
              </p>

              <h5 className="mt-3">Why Little Paws Place exists</h5>
              <p>
                Little Paws Place started with a simple idea:{" "}
                <strong>
                  every pet deserves to be protected, identified, and supported
                  beyond just a collar tag.
                </strong>{" "}
                Traditional tags only show a phone number. If that number
                changes or you miss a call, the trail goes cold. We wanted
                something smarter.
              </p>

              <h5 className="mt-4">What is a Little Paws SmartTag?</h5>
              <p>
                A <strong>Little Paws SmartTag</strong> is a unique ID (like{" "}
                <code>LP####</code>) that links your pet to a secure online
                profile and AI assistant. When someone scans or visits your tag
                link:
              </p>
              <ul>
                <li>
                  They can quickly see safe, owner-approved information about
                  your pet.
                </li>
                <li>
                  You stay in control of what’s shared and how you’re contacted.
                </li>
                <li>
                  Our system helps keep everything updated, organized, and easy
                  to manage.
                </li>
              </ul>

              <h5 className="mt-4">AI that works for you (and your pet)</h5>
              <p>
                With an active plan, your SmartTag unlocks{" "}
                <strong>Paw AI</strong> — a pet-focused assistant designed to
                help you:
              </p>
              <ul>
                <li>Keep key info about your pet in one place.</li>
                <li>
                  Walk through SmartTag setup via a guided conversation, not
                  confusing forms.
                </li>
                <li>
                  Get gentle reminders and support around your pet’s needs and
                  routine.
                </li>
              </ul>

              <h5 className="mt-4">How it works</h5>
              <ol>
                <li>Purchase a Little Paws SmartTag.</li>
                <li>Create your account using the ID printed on your tag.</li>
                <li>
                  Activate your plan and let Paw AI guide you through setting up
                  your pet’s profile.
                </li>
              </ol>

              <p className="mt-4">
                Our goal isn’t to replace your vet or trainer — it’s to give you
                a <strong>simple, always-available companion</strong> for the
                everyday details of caring for your pet.
              </p>

              <div className="text-center mt-4">
                <Button
                  variant="primary"
                  className="me-2 mb-2"
                  onClick={() => navigate("/smarttag")}
                >
                  Activate My SmartTag
                </Button>
                <Button
                  variant="outline-secondary"
                  className="mb-2"
                  onClick={() => navigate("/contact-support")}
                >
                  Contact Support
                </Button>
              </div>

              <div className="text-center mt-3">
                <Button variant="light" size="sm" onClick={() => navigate(-1)}>
                  ← Back
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
